module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v(_vm._s(_vm.$T('餐饮预订')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addMealRow
    }
  }, [_vm._v(_vm._s(_vm.$T('添加预约')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "plain": "",
      "icon": "el-icon-delete",
      "disabled": _vm.mealList.length === 0
    },
    on: {
      "click": _vm.clearAllMeals
    }
  }, [_vm._v(_vm._s(_vm.$T('清空全部')))])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.mealList,
      "border": "",
      "stripe": "",
      "size": "mini",
      "empty-text": _vm.$T('暂无餐饮预订，可点击添加或直接下一步清空')
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$T('场地'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": _vm.$T('请选择场地'),
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.onVenueChange(scope.row)
            }
          },
          model: {
            value: (scope.row.venue_id),
            callback: function($$v) {
              _vm.$set(scope.row, "venue_id", $$v)
            },
            expression: "scope.row.venue_id"
          }
        }, _vm._l((_vm.venueOptions), function(venue) {
          return _c('el-option', {
            key: venue.id,
            attrs: {
              "label": venue.title,
              "value": venue.id
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('套餐类型'),
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "placeholder": _vm.$T('请选择套餐'),
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.onMealTypeChange(scope.row)
            }
          },
          model: {
            value: (scope.row.meal_set_id),
            callback: function($$v) {
              _vm.$set(scope.row, "meal_set_id", $$v)
            },
            expression: "scope.row.meal_set_id"
          }
        }, _vm._l((_vm.getMealSetByVenue(scope.row.venue_id)), function(mealSet) {
          return _c('el-option', {
            key: mealSet.id,
            attrs: {
              "label": mealSet.name,
              "value": mealSet.id
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('数量'),
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticStyle: {
            "width": "80px"
          },
          attrs: {
            "type": "number",
            "min": "1"
          },
          on: {
            "change": function($event) {
              return _vm.normalizeQuantity(scope.row)
            }
          },
          model: {
            value: (scope.row.quantity),
            callback: function($$v) {
              _vm.$set(scope.row, "quantity", _vm._n($$v))
            },
            expression: "scope.row.quantity"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('价格'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(Number(scope.row.price || 0).toFixed(2)) + " USD")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('小计'),
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(Number(_vm.rowSubtotal(scope.row)).toFixed(2)) + " USD")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('状态'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.statusLabel(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('操作'),
      "width": "90",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "color": "#f56c6c"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeMealRow(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('删除')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('span', [_vm._v(_vm._s(_vm.$T('总数量')) + ": " + _vm._s(_vm.totalQuantity))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$T('总价')) + ": " + _vm._s(_vm.totalPrice.toFixed(2)) + " USD")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.onNextStep
    }
  }, [_vm._v(_vm._s(_vm.$T('下一步')))])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59baff3d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep4.vue
// module id = 1463
// module chunks = 0